/* Copyright (c) 2021 MOCA Systems, Inc.  All rights reserved. */

import { FancyAction } from 'src/app/common/fancy-firebase/base/FancyAction';
import { FancyActionableFirebase } from 'src/app/common/fancy-firebase/generics/FancyActionableFirebase';
import { CustomFieldTicketValueList } from 'src/app/common/fancy-firebase/lists/CustomFieldTicketValueList';
import { CustomFieldTicketValue } from '../models/CustomFieldTicketValue';

export class CustomFieldTicketValues extends FancyActionableFirebase<
	CustomFieldTicketValue,
	FancyAction,
	CustomFieldTicketValueList
> {
	constructor(public data: CustomFieldTicketValueList) {
		super(data);
	}
}
